export const SET_END_DOCUMENT_MODE = 'SET_END_DOCUMENT_MODE'
export const SET_ALI_SEGMENT = 'SET_ALI_SEGMENT'
export const SET_ALI_OPEN_SIDEBAR = 'SET_ALI_OPEN_SIDEBAR'
export const SET_ALI_DRAWER_WIDTH = 'SET_ALI_DRAWER_WIDTH'
export const SET_FULL_SCREEN = 'SET_FULL_SCREEN'
export const SET_SHOW_DATATOPIC_MODAL = 'SET_SHOW_DATATOPIC_MODAL'
export const SET_SMART_FLOW = 'SET_SMART_FLOW'
export const SET_SELECTED_PERSONA = 'SET_SELECTED_PERSONA'
export const SET_CHAT_MODELS = 'SET_CHAT_MODELS'
export const SET_SELECTED_CHAT_MODEL = 'SET_SELECTED_CHAT_MODEL'
export const SET_MCP_SERVERS = 'SET_MCP_SERVERS'

export function setAliOpenSideBar(openSidebar) {
  return {
    type: SET_ALI_OPEN_SIDEBAR,
    payload: {
      openSidebar
    }
  }
}

export function setAliDrawerWidth(width) {
  return {
    type: SET_ALI_DRAWER_WIDTH,
    payload: width
  }
}

export function setFullScreen(isFullScreen) {
  return {
    type: SET_FULL_SCREEN,
    payload: isFullScreen
  }
}

export function setShowSmartFlow(showSmartFlow) {
  return {
    type: SET_SMART_FLOW,
    payload: showSmartFlow
  }
}

export function setShowDataTopicModal(showDataTopicModal) {
  return {
    type: SET_SHOW_DATATOPIC_MODAL,
    payload: showDataTopicModal
  }
}

export function setSelectedAgent(selectedAgent) {
  return {
    type: SET_SELECTED_PERSONA,
    payload: selectedAgent
  }
}

export function setChatModels(chatModels) {
  return {
    type: SET_CHAT_MODELS,
    payload: chatModels
  }
}

export function setSelectedChatModel(selectedModel) {
  return {
    type: SET_SELECTED_CHAT_MODEL,
    payload: selectedModel
  }
}

export function setMCPServers(servers) {
  return {
    type: SET_MCP_SERVERS,
    payload: servers
  }
}
